import { Button } from "@web/components/ui/button.tsx";
import type { ErrorAction } from "#shared/errors/registry.ts";
import { useConnectSpotify } from "@web/features/library/api.ts";

/** Run the registry action (reconnect / retry / reload). */
export function ErrorActionButton({
  action,
  onRetry,
}: {
  action: ErrorAction;
  onRetry?: () => void;
}) {
  const connect = useConnectSpotify();

  if (action.kind === "none") return null;

  if (action.kind === "reconnect_spotify" || action.kind === "connect_spotify") {
    return (
      <Button
        type="button"
        size="sm"
        disabled={connect.isPending}
        onClick={() => connect.mutate()}
      >
        {action.label}
      </Button>
    );
  }

  if (action.kind === "reload") {
    return (
      <Button type="button" size="sm" onClick={() => window.location.reload()}>
        {action.label}
      </Button>
    );
  }

  if (action.kind === "retry") {
    if (!onRetry) return null;
    return (
      <Button type="button" size="sm" variant="secondary" onClick={onRetry}>
        {action.label}
      </Button>
    );
  }

  return null;
}
